import type { Common, CustomField, MstCommon } from '@libs/domain';
import type { CustomFieldAttribute } from '@libs/enums';
import { customFieldAttribute } from '@libs/enums';

class CustomFieldBasicSetting
  implements
    Pick<MstCommon['schema'], 'codeDigits' | 'displayName'>,
    Pick<Common['schema'], 'isUsed'>,
    Pick<CustomField['schema'], 'customFieldKey' | 'attribute'>
{
  private constructor(
    readonly customFieldKey: number,
    readonly isUsed: boolean,
    readonly displayName: string,
    readonly attribute: CustomFieldAttribute,
    readonly codeDigits: string,
  ) {}

  static fromRaw(raw: CustomFieldBasicSettingRaw) {
    return new CustomFieldBasicSetting(
      raw.customFieldKey,
      raw.isUsed,
      raw.displayName,
      customFieldAttribute.toEnum(raw.attribute),
      raw.codeDigits,
    );
  }
}

class CustomFieldBasicSettingRaw
  implements
    Pick<MstCommon['record'], 'codeDigits' | 'displayName'>,
    Pick<Common['record'], 'isUsed'>,
    Pick<CustomField['record'], 'customFieldKey'>
{
  private constructor(
    readonly customFieldKey: number,
    readonly isUsed: boolean,
    readonly displayName: string,
    readonly attribute: string,
    readonly codeDigits: string,
  ) {}

  static fromModel(model: CustomFieldBasicSetting, defaultName: string) {
    return new CustomFieldBasicSettingRaw(
      model.customFieldKey,
      model.isUsed,
      model.isUsed ? model.displayName : model.displayName ? model.displayName : defaultName,
      model.attribute,
      model.isUsed ? model.codeDigits : model.codeDigits ? model.codeDigits : '',
    );
  }

  static fromModels(models: CustomFieldBasicSetting[], defaultNames: string[]) {
    return models.map((s, i) => CustomFieldBasicSettingRaw.fromModel(s, defaultNames[i]));
  }
}

export { CustomFieldBasicSetting, CustomFieldBasicSettingRaw };
